// extracted by mini-css-extract-plugin
export default {"svg":"RedirectNode_svg__mTP3N","placeholder":"RedirectNode_placeholder__iYh5D","deleteIcon":"RedirectNode_deleteIcon__aLNzq"};